import React from 'react';
import AppIndustrial from './App-industrial';

function App() {
  return <AppIndustrial />;
}

export default App;
